import {ctaClick} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withCtaClickEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, ctaClick, options)

export default withCtaClickEvent
